import { ComponentProps } from 'react';
import { DataTable } from '../../../design-system/data-table/data-table';
import { TransactionView } from '../../../types/entity-types';
import { transactionsTableColumnsDefinition } from './table-columns/transactions-table-columns-definition';

type DataTableProps = ComponentProps<typeof DataTable>;

type TransactionTableProps = Omit<DataTableProps, 'data' | 'columns'> & {
  transactions: TransactionView[];
};

export const TransactionTable = ({ transactions, ...props }: TransactionTableProps) => {
  return <DataTable<TransactionView> columns={transactionsTableColumnsDefinition} data={transactions} {...props} />;
};
